<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
              <b-col md="10">
                <h3 tabindex="0">Visualizar Delegados</h3>
              </b-col>
            </b-row>
        </b-card-header>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                  <b-alert v-model="showMessage" variant="primary" dismissible>
                    {{ mensagem }}
                  </b-alert>
                  <span>
                    <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                    <thead>
                      <tr>
                        <th scope="col">Situação</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Perfil</th>
                        <th scope="col">UF</th>
                        <th scope="col">E-mail</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>

                    <tbody v-if="participantes.data !== undefined">
                      <tr class="action" v-for="participante in participantes.data" :key="participante.id_user">
                        <td  v-if="participante.situacao === 'P'">
                          <span class="badge badge-primary">Pendente</span>
                        </td>
                        <td >{{participante.nome}}</td>
                        <td >{{participacoes[participante.participacao]}}</td>
                        <td >{{participante.cidade_moradia.estado.sigla}}</td>

                        <td >{{participante.email}}</td>
                        <td style="width: 15%">
                            <a v-if="can('participante.show')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarParticipante(participante.id)">
                              <i class="fa fa-search"></i>
                            </a>
                            <a v-if="!participante.user" class="btn btn-sm btn-secondary action" title="Gerar Usuário" @click="gerarUser(participante.id)"  :disabled="loading">
                              <i class="fa fa-user"></i>
                            </a>
                            <a v-if="participante.user" class="btn btn-sm btn-secondary action" title="Gerar Usuário" @click="enviarSenha(participante.id)"  :disabled="loading">
                              <i class="fa fa-paper-plane"></i>
                            </a>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="action">
                        <td colspan="6">Nenhum registro de delegados...</td>
                      </tr>
                    </tbody>
                    </table>
                    <pagination v-show="participantes.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                  </span>
                </b-container>
            </b-col>
        </b-row>
        <b-card-footer class="p-12">
          <b-row>
            <b-col md="3">
              <b-button block variant="success"  @click="gerarUsers" :disabled="loading">
                <i class="fa fa-users"></i>&nbsp;&nbsp;<span>Gerar Usuários</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="primary"  @click="navigate('/participante')">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

setupCalendar({
  firstDayOfWeek: 2
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {
    if (!this.can('participante.index')) {
      this.$router.push('/')
    }
    this.$store.dispatch('getParticipacoes')
    this.mensagem = ''
    this.showMessage = false
  },
  data () {
    return {
      totalPorPagina: 10,
      resource: 'participante/tipo/delegado',
      modalCredenciar: false,
      modalCertificar: false,
      filtros: {
        uf: null,
        participacao: 'D',
        filter: ''
      },
      showMessage: false,
      mensagem: '',
      loading: false
    }
  },
  computed: {
    participantes () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    participante () {
      return this.$store.state.participante.participante
    },
    participacoes () {
      return this.$store.state.participacao.participacoes
    },
    eventos () {
      return this.$store.state.evento.eventos
    },
    estados () {
      return this.$store.state.estado.listaEstados
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.participacao': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.uf': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    }
  },
  methods: {
    enviarSenha (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja enviar a senha?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/participante/usuario/novasenha/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(e.body.msg, 'Alerta', 5000)
            this.loading = false
          })
        }
      }).catch(erro => {})
    },
    gerarUser (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/participante/usuario/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(e.body.msg, 'Alerta', 5000)
            this.loading = false
          })
        }
      }).catch(erro => {})
    },
    gerarUsers () {
      this.mensagem = ''
      this.showMessage = false

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/participante/usuarios', {}).then(response => {
            this.loading = false
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})

              if (response.body.data.naoGerados !== '') {
                this.mensagem = 'Os seguintes delegados não forma gerados devido ao e-mail já estar sendo utilizado: ' + response.body.data.naoGerados
                this.showMessage = true
              }
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
          }).catch(e => {
            this.loading = false
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {})
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarParticipante (id) {
      this.$router.push('/participante/visualizar/' + id)
    },
    resetForm () {
      this.motivo = ''
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/participante/Delegado.vue